import {IValidator} from './IValidator';
import {Injectable} from '@angular/core';
import {ConstantsService} from '../../../../services/constants.service';

declare let THREE: any;

@Injectable()
export class WallRangeValidator implements IValidator {

  private wallBox = new THREE.Box3();
  private objectBox = new THREE.Box3();
  private upVec = new THREE.Vector3(0, 1, 0);
  private wallCenter = new THREE.Vector3(0, 1, 0);
  private deckHeight = 0;
  private wallSize = new THREE.Vector3(0, 0, 0);
  private objectSize = new THREE.Vector3(0, 0, 0);

  constructor(
    constantsSrvc: ConstantsService
  ) {
    this.deckHeight = constantsSrvc.deckHeight;
  }

  private applyRotation(vec, axis, rotation) {
    vec.applyAxisAngle(axis, rotation);
    vec.set(
      Math.abs(vec.x),
      Math.abs(vec.y),
      Math.abs(vec.z)
    );
    return vec;
  }

  validate(object, newSize, newPosition) {
    const wall = object.parent;
    const wallYRotation = wall.rotation.y;
    const {depth, height, width} = wall.userData.config.firstPoint;
    wall.updateMatrixWorld();
    wall.getWorldPosition(this.wallCenter);
    this.wallCenter.y += this.deckHeight / 2;

    this.wallSize.set(width, height - this.deckHeight, depth);
    this.applyRotation(this.wallSize, this.upVec, wallYRotation);
    this.wallBox.setFromCenterAndSize(this.wallCenter, this.wallSize);

    this.objectSize.set(newSize.x, newSize.y, 1);
    this.applyRotation(this.objectSize, this.upVec, wallYRotation);
    this.objectBox.setFromCenterAndSize(newPosition, this.objectSize);

    return this.wallBox.containsBox(this.objectBox);
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/Validators/WallRangeValidator.ts